/* eslint-disable no-unused-vars */
// 入参配置操作日志
import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import classnames from 'classnames';
import { useEffect, useCallback } from 'react';
// import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import { history } from 'umi';

const MemberManagement = (props) => {
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['dgcl/inputItemConfigLog'];
  let datas = useSelector((state) => state.dgcl.inputItemConfigLog);

  // 获取会员列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'dgcl/inputItemConfigLog',
      payload: {
        values: {
          nodeId: history.location.query.nodeId,
        },
      },
    });
  }, [dispatch]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  let tableData = datas || [];

  return (
    <div className={styles.mm_content}>
      <div
        className={classnames(styles.search_group, styles.single_component1)}
      ></div>
      {/* <p className={styles.nodeName}>节点名称：{decodeURIComponent(history.location.query.nodeName)}</p> */}
      <div className={classnames(styles.table_page, styles.single_component)}>
        {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
        <TablePage
          loading={loading}
          tableData={tableData}
          loadingstatus={loading}
        />
      </div>
    </div>
  );
};

export default MemberManagement;
